import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from 'assets/images/main-page/7bit_logo.svg'


const _hoisted_1 = { class: "modal-content-signup" }
const _hoisted_2 = { class: "modal-banner" }
const _hoisted_3 = { class: "modal-inside" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = {
  key: 0,
  class: "modal-text"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = ["type"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 0.363647C4.36364 0.363647 1.25818 2.62547 0 5.81819C1.25818 9.01092 4.36364 11.2727 8 11.2727C11.6364 11.2727 14.7418 9.01092 16 5.81819C14.7418 2.62547 11.6364 0.363647 8 0.363647ZM8 9.45456C5.99273 9.45456 4.36364 7.82547 4.36364 5.81819C4.36364 3.81092 5.99273 2.18183 8 2.18183C10.0073 2.18183 11.6364 3.81092 11.6364 5.81819C11.6364 7.82547 10.0073 9.45456 8 9.45456ZM8 3.63637C6.79273 3.63637 5.81818 4.61092 5.8181 5.81819C5.81818 7.02547 6.79273 8.00001 8 8.00001C9.20727 8.00001 10.1818 7.02547 10.1818 5.81819C10.1818 4.61092 9.20727 3.63637 8 3.63637Z",
    fill: "#C6A9E3",
    "fill-opacity": "0.65"
  })
], -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.1172 17.0654C10.7231 17.201 11.3531 17.2726 12 17.2726C15.6364 17.2726 18.7418 15.0108 20 11.8181C19.343 10.1509 18.1823 8.7375 16.7053 7.76749L15.1377 9.97983C15.4546 10.5193 15.6364 11.1476 15.6364 11.8181C15.6364 13.8253 14.0073 15.4544 12 15.4544C11.7626 15.4544 11.5304 15.4316 11.3056 15.3881L10.1172 17.0654ZM12.3041 13.979C13.3668 13.8315 14.1818 12.9221 14.1818 11.8181C14.1818 11.6709 14.1673 11.5272 14.1397 11.3883L12.3041 13.979ZM11.6889 9.65815L9.8589 12.2408C9.83218 12.1041 9.81818 11.9628 9.81818 11.8181C9.81818 10.7165 10.6296 9.80861 11.6889 9.65815ZM12.6888 8.24695C12.4657 8.20413 12.2355 8.18171 12 8.18171C9.99273 8.18171 8.36364 9.8108 8.36364 11.8181C8.36364 12.4865 8.5443 13.113 8.85944 13.6514L7.29042 15.8658C5.81547 14.8959 4.65637 13.4837 4 11.8181C5.25818 8.62534 8.36364 6.36353 12 6.36353C12.6449 6.36353 13.2732 6.43467 13.8773 6.56953L12.6888 8.24695Z",
    fill: "#C6A9E3",
    "fill-opacity": "0.65"
  }),
  /*#__PURE__*/_createElementVNode("rect", {
    x: "6.78003",
    y: "18.2397",
    width: "18",
    height: "1",
    transform: "rotate(-54.6804 6.78003 18.2397)",
    fill: "#8C77A0"
  })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "form-group__bonus-label" }
const _hoisted_13 = ["value", "placeholder"]
const _hoisted_14 = {
  key: 0,
  href: "#",
  class: "form-group__bonus-not"
}
const _hoisted_15 = {
  key: 1,
  href: "#",
  class: "form-group__bonus-not"
}
const _hoisted_16 = { class: "form-group form-checkbox" }
const _hoisted_17 = {
  for: "agree",
  class: "form-checkbox__label"
}
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "form-checkbox-span" }, "*", -1)
const _hoisted_20 = { class: "form-switch" }
const _hoisted_21 = ["title"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "form-switch__label" }, null, -1)
const _hoisted_23 = { class: "form-switch__text" }
const _hoisted_24 = { class: "form-switch" }
const _hoisted_25 = ["title"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-switch__label" }, null, -1)
const _hoisted_27 = { class: "form-switch__text" }
const _hoisted_28 = { class: "form-group text-center" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loader" }, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "modal-text"
}
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-footer\" style=\"display:none;\"><a href=\"#\"><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.6399 2.34842e-05H1.62717C1.04082 2.34842e-05 0.56543 0.497024 0.56543 1.11102V18.903C0.573082 19.51 1.04656 20 1.62813 20H10.7945V12.265H8.29986V9.24002H10.784V7.01702C10.784 4.43302 12.2933 3.02702 14.5048 3.02702C15.248 3.02402 15.9922 3.06302 16.7316 3.14402V5.83402H15.206C14.0103 5.83402 13.7731 6.42902 13.7731 7.30302V9.23902H16.6407L16.2677 12.265H13.7731V20H18.6399C19.2214 19.996 19.692 19.504 19.6959 18.896V1.11002C19.6959 0.500023 19.2243 0.00302344 18.6399 -0.000976562V2.34842e-05Z\" fill=\"white\"></path></svg> Faceboock </a><a href=\"#\"><svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.6084 3.48C10.2249 3.48 11.3154 4.21 11.9371 4.82L14.3667 2.34C12.8745 0.89 10.9328 0 8.6084 0C5.24145 0 2.33362 2.02 0.917969 4.96L3.70145 7.22C4.39971 5.05 6.33188 3.48 8.6084 3.48Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.8727 9.20011C16.8727 8.46011 16.8154 7.92011 16.691 7.36011H8.6084V10.7001H13.3527C13.2571 11.5301 12.7406 12.7801 11.5927 13.6201L14.3093 15.8201C15.9354 14.2501 16.8727 11.9401 16.8727 9.20011Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.7113 10.78C3.52957 10.22 3.42435 9.61996 3.42435 8.99996C3.42435 8.37996 3.52957 7.77996 3.70174 7.21996L0.918261 4.95996C0.334783 6.17996 0 7.54996 0 8.99996C0 10.45 0.334783 11.82 0.918261 13.04L3.7113 10.78Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.6086 18C10.933 18 12.8843 17.2 14.3095 15.82L11.593 13.62C10.866 14.15 9.89034 14.52 8.6086 14.52C6.33208 14.52 4.39991 12.95 3.71121 10.78L0.927734 13.04C2.34339 15.98 5.24165 18 8.6086 18Z\" fill=\"white\"></path></svg> Google </a></div>", 1)
const _hoisted_33 = ["value"]
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "modal-three-block" }
const _hoisted_36 = { class: "form-checkbox" }
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = { for: "checkbox1" }
const _hoisted_39 = { class: "checkbox-text" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9 0C8.44771 0 8 0.447715 8 1C8 1.55228 8.44771 2 9 2H10.5858L7.75739 4.8284C6.96696 4.30488 6.01908 4 5 4C2.23858 4 0 6.23858 0 9C0 11.7614 2.23858 14 5 14C7.76142 14 10 11.7614 10 9C10 7.98092 9.69512 7.03304 9.1716 6.24261L12 3.41421V5C12 5.55228 12.4477 6 13 6C13.5523 6 14 5.55228 14 5V1C14 0.447715 13.5523 0 13 0H9ZM5 12C6.65685 12 8 10.6569 8 9C8 7.34315 6.65685 6 5 6C3.34315 6 2 7.34315 2 9C2 10.6569 3.34315 12 5 12Z",
    fill: "#89878B"
  })
], -1)
const _hoisted_41 = { class: "form-checkbox" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { for: "checkbox2" }
const _hoisted_44 = { class: "checkbox-text" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8 8C9.65685 8 11 6.65685 11 5C11 3.34315 9.65685 2 8 2C6.34315 2 5 3.34315 5 5C5 6.65685 6.34315 8 8 8ZM13 5C13 7.41896 11.2822 9.43671 9 9.89998V12H10C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14H9V15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15V14H6C5.44772 14 5 13.5523 5 13C5 12.4477 5.44772 12 6 12H7V9.89998C4.71776 9.43671 3 7.41896 3 5C3 2.23858 5.23858 0 8 0C10.7614 0 13 2.23858 13 5Z",
    fill: "#89878B"
  })
], -1)
const _hoisted_46 = { class: "modal-footer" }
const _hoisted_47 = ["title"]
const _hoisted_48 = ["title"]
const _hoisted_49 = ["value", "title"]
const _hoisted_50 = ["value", "title"]
const _hoisted_51 = ["value", "title"]
const _hoisted_52 = { class: "modal-footer" }
const _hoisted_53 = ["title", "disabled"]
const _hoisted_54 = ["title", "disabled"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loader" }, null, -1)
const _hoisted_56 = { class: "modal-four-bonus" }
const _hoisted_57 = { class: "modal-four-bonus-title" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("img", {
  class: "modal-four-bonus-img",
  src: _imports_0,
  alt: "7bit_logo_2021"
}, null, -1)

import { RegFormInterface } from '@/types/regForm.interface';
import { SsUsersRegisterErrorsParsedInterface } from '@/types/softswiss/ssUsers.response.interface';
import { RegistrationFormInterface } from '~/types/registrationForm.interface';
import {
  computed,
  ref,
  reactive,
  watch,
  onBeforeUnmount,
} from 'vue';
import { useStore } from 'vuex';
import { StrapiProfileFormInterface } from '@/types/strapiProfileForm.interface';
import CustomSelect from '@/components/customSelect/customSelect.vue';
import BannerSlider from '@/components/bannerSlider/bannerSlide.vue';
import { useRegForm } from '@/composables/useRegForm';
import { SsCountriesResponseInterface } from '@/types/softswiss/ssCountriesResponse.interface';
import TelephoneInput from '@/components/telephoneInput.vue';
import {
  generateAuthToken,
  registerPlayer,
  updateProfile,
} from '@/services/registerPalayer';
import { checkEmail } from '@/services/validateEmail';
import { registrationErrorsParser } from '@/utils/registerErrorsParser';
import { useGtmPush } from '@/composables/gtm';
import { PromoPageInterface } from '@/types/promoPage.interface';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  props: {
    lang: null,
    selectedCurrency: null,
    pageData: null
  },
  emits: ["changeCurrency"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'changeCurrency', currency: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  lang: string;
  selectedCurrency: string;
  pageData: PromoPageInterface;
}



const store = useStore();

const { push } = useGtmPush();

const regFormData = computed(
  (): RegFormInterface => store.getters['regForm/formData']
);

const profileFormData = computed(
  (): StrapiProfileFormInterface => store.getters['profileForm/formData']
);

const isDesktop = computed(() => store.getters['platform/isDesktop']);
const isMobile = computed(() => store.getters['platform/isMobile']);
const isTablet = computed(() => store.getters['platform/isTablet']);

const { activeCurrencies, userCountry, currencies } = useRegForm({});

store.dispatch('ssCountries/load');

const redirectHost = computed(() => store.getters['systemHosts/redirectHost']);
const ssHost = computed(() => store.getters['systemHosts/ssHost']);

/**
 * getter for selected options with a key
 */
const activeCurrenciesOptions = computed((): string[] => {
  return activeCurrencies.value.map((currency) => {
    return currency.currency_code;
  });
});

/**
 * current step of registration
 */

const step = ref(1);

/**
 * list of error at registartion process (step 1)
 */
const regErrors = ref({} as SsUsersRegisterErrorsParsedInterface);

/**
 * user registration form data (step 1)
 */
const regForm: RegistrationFormInterface = reactive({
  email: '',
  password: '',
  currency: props.selectedCurrency,
  terms_acceptance: false,
  bonus_code: '',
});



const changeCurrency = (currency: string) => {
  emit('changeCurrency', currency);
};

watch(
  () => regForm.currency,
  (newCurrency) => {
    changeCurrency(newCurrency);
  },
  { immediate: true }
);

/**
 * user password visibility flag (step 1)
 */
const showPassword = ref(false);

/**
 * method for set status of user password visibility
 * show or hide password for user eyes
 */
const showPasswordToggle = (setStatus?: boolean): void => {
  if (typeof setStatus === 'boolean') {
    showPassword.value = setStatus;
  } else {
    showPassword.value = !showPassword.value;
  }
};

// modal open send gtm
push({
  vCategory: 'regform',
  vAction: 'regform_open',
  vLabel: `step_1`,
});

/**
 * flag for loading form process
 */
const waitPlease = ref(false);

/**
 * user profile edit form data (step 2 & 3)
 */
const profileForm = reactive({
  first_name: '',
  last_name: '',
  country: '',
  gender: '',
  mobile_phone: '',
  postal_code: '',
  receive_promos: false,
  receive_sms_promos: false,
  month: '',
  year: '',
  day: '',
  address: '',
  city: '',
});

/**
 * list of error at profile update process (step 2 & 3)
 */
const profileErrors = ref({} as any);

/**
 * step 2 field names for error detection and open step with errors
 */
const step2fields = reactive([
  'first_name',
  'last_name',
  'date_of_birth',
  'mobile_phone',
  'gender',
]);

/**
 * step 3 field names for error detection and open step with errors
 */
const step3fields = reactive(['country', 'city', 'address', 'postal_code']);

const termsLink = computed(() => {
  return `/terms-and-conditions`;
});

/**
 * getter for input type return password field
 * (visibility of user password))
 */
const passwordType = computed((): 'text' | 'password' => {
  return showPassword.value ? 'text' : 'password';
});

/**
 * getter for list of available years for the user who are 18 years
 */
const listYears = computed((): number[] => {
  const arrYears: number[] = [];
  const listYears = new Date().getFullYear() - 18;
  for (let i = listYears; i > listYears - 82; --i) {
    arrYears.push(i);
  }
  return arrYears;
});

/**
 * getter for list of available months for the user who are 18 years
 */
const listMonths = computed((): number[] => {
  let months = 12;
  // check who are 18 years and separated permitted months
  if (+profileForm.year === listYears.value[0]) {
    const monthCount = new Date().getMonth() + 1;
    months = monthCount;
    if (+profileForm.month > months) {
      // eslint-disable-next-line prettier/prettier
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      profileForm.month = `${months}`;
    }
  }
  const monthArray = [];
  for (let i = 1; i <= months; i++) {
    monthArray.push(i);
  }
  return monthArray;
});

/**
 * getter for list of available days for the user who are 18 years
 */
const listDays = computed((): number[] => {
  let days = 31;
  // check who select year and month and separated permitted days
  if (profileForm.year && profileForm.month) {
    days = new Date(+profileForm.year, +profileForm.month, 0).getDate();
    // Checks the days at month and overwrites if value more days-counted
    if (+profileForm.day > days) {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      profileForm.day = `${days}`;
    }
    // check who are 18 years and separated permitted days
    if (
      +profileForm.year === listYears.value[0] &&
      new Date().getMonth() + 1 === +profileForm.month
    ) {
      const dayCount = new Date().getDate();
      days = dayCount - 1;
      if (+profileForm.day > days) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        profileForm.day = `${days}`;
      }
    }
  }
  const dayArray = [];
  for (let i = 1; i <= days; i++) {
    dayArray.push(i);
  }
  return dayArray;
});

const birthDate = computed((): string => {
  const day =
    Number(profileForm.day) > 9
      ? Number(profileForm.day)
      : `0${Number(profileForm.day)}`;

  const month =
    Number(profileForm.month) > 9
      ? Number(profileForm.month)
      : `0${Number(profileForm.month)}`;

  return `${profileForm.year}-${month}-${day}`;
});

/**
 * show bonus code
 */
const isBonusActive = ref(false);

/**
 * Method for toggling bonus showing
 */
const toggleBonusShow = () => {
  isBonusActive.value = !isBonusActive.value;
};

const countries = computed((): SsCountriesResponseInterface[] => {
  return store.getters['ssCountries/countries'];
});

const countriesList = computed((): { [key: string]: string } => {
  const countriesList: { [key: string]: string } = {};

  if (countries.value && countries.value.length) {
    countries.value.forEach((country) => {
      countriesList[country.code] = country.name;
    });
  }

  return countriesList;
});

/**
 * Method for user data loading which set country and currency for user
 */
const loadLocalizedUserData = () => {
  if (userCountry.value) {
    if (!profileForm.country) {
      profileForm.country =
        countries.value.find(
          (c) =>
            String(c.code).toUpperCase() ===
            String(userCountry.value).toUpperCase()
        )?.code || '';
    }
  }
};

watch(() => countries.value, loadLocalizedUserData, { immediate: true });

const updateProfileData = async () => {
  if (profileForm.mobile_phone[0] !== '+') {
    profileForm.mobile_phone = '+' + profileForm.mobile_phone;
  }

  const profileData = {
    ...profileForm,
    date_of_birth: birthDate.value,
    year: undefined,
    month: undefined,
    day: undefined,
  };

  profileErrors.value = {};

  // console.log('try:', profileData);
  const result = await updateProfile(profileData, ssHost.value, props.lang);

  // console.log('result:', result);

  if (result?.errors) {
    Object.keys(result.errors).forEach((e) => {
      profileErrors.value[e] = Object.values(result.errors[e]).join(', ');
    });

    // console.log(this.profileErrors);
    return false;
  }

  // console.log(result);
  return true;
};

const route = useRoute();
const stag = String(route?.query?.stag || '');
const token = ref(null);

/**
 * register() method is used to register user with SS API
 * and send info about referral (stag) to SS if user inputs bonus code
 * that belongs to affiliate partner
 **/
const register = async () => {
  const playerInfo = {
    email: regForm.email,
    password: regForm.password,
    password_confirmation: regForm.password,
    bonus_code: String(regForm.bonus_code).toUpperCase(),
    profile_attributes: {
      nickname: regForm.email.substring(0, 4) + '****',
      currency: regForm.currency.toUpperCase(),
      terms_acceptance: !!regForm.terms_acceptance,
      receive_promos: profileForm.receive_promos,
      receive_sms_promos: profileForm.receive_sms_promos,
    },
  };
  let isEmailValid = true;
  // Disabling email checker for Magnetics emails
  if (!playerInfo.email.includes('magnetics.io')) {
    isEmailValid = await checkEmail(playerInfo.email);
  }
  if (!isEmailValid) {
    regErrors.value.email = 'Email does not exist';
    return false;
  }

  // const getBonus = await this.findAffiliateBonusCode(playerInfo.bonus_code);

  // if (getBonus) {
  //   await this.checkStag(getBonus.stag);
  // }

  const registrationResult = await registerPlayer(
    playerInfo,
    ssHost.value,
    props.lang
  );

  if (registrationResult.errors) {
    regErrors.value = registrationErrorsParser(registrationResult.errors);
    return false;
  }

  const isCrypto = !!currencies.value.find(
    (cur) => cur.currency_code === playerInfo.profile_attributes.currency
  )?.crypto;

  token.value = generateAuthToken({
    login: playerInfo.email,
    password: playerInfo.password,
    stag,
    modal: isCrypto ? `deposit` : `signup`,
  });

  return true;
};

const redirectToWelcomeBonus = () => {
  push({
    vCategory: 'landing_form',
    vAction: 'Success',
  });

  window.location.href = `https://${redirectHost.value}?auth=${token.value}&stag=${stag}`;
};

const prevStep = () => {
  if (step.value === 3) {
    step.value = 2;
  }
};

const nextStep = async () => {
  waitPlease.value = true;

  push({
    vCategory: 'regform',
    vAction: 'regform_success',
    vLabel: 'step_1',
  });

  if (step.value === 1 && (await register())) {
    if (
      currencies.value.some(
        (c) => c.currency_code === regForm.currency && c.crypto
      )
    ) {
      return redirectToWelcomeBonus();
    } else {
      step.value = 2;
    }
  } else if (step.value === 2 && checkFields(2)) {
    push({
      vCategory: 'regform',
      vAction: 'regform_success',
      vLabel: 'step_2',
    });

    step.value = 3;
  } else if (step.value === 3 && checkFields()) {
    if (await updateProfileData()) {
      push({
        vCategory: 'regform',
        vAction: 'regform_success',
        vLabel: 'step_3',
      });

      return redirectToWelcomeBonus();
    } else if (step2fields.some((f) => profileErrors.value[f])) {
      push({
        vCategory: 'regform',
        vAction: 'regform_fail',
        vLabel: 'step_2',
      });
      step.value = 2;
    } else {
      push({
        vCategory: 'regform',
        vAction: 'regform_fail',
        vLabel: 'step_3',
      });
    }
  }

  waitPlease.value = false;
};

const checkFields = (step?: 2 | 3): boolean => {
  profileErrors.value = {};

  if (!step || step === 2) {
    step2fields
      .filter((f) => f !== 'date_of_birth')
      .forEach((f) => {
        // @ts-ignore
        if (!profileForm[f]) {
          profileErrors.value[f] = 'cant be blank!';
        }
      });

    if (!profileForm.year || !profileForm.month || !profileForm.day) {
      profileErrors.value.date_of_birth = 'cant be blank!';
    }
  }

  if (!step || step === 3) {
    step3fields.forEach((f) => {
      // @ts-ignore
      if (!profileForm[f]) {
        profileErrors.value[f] = 'cant be blank!';
      }
    });
  }

  return !Object.keys(profileErrors.value).length;
};

/**
 * method for close this modal
 */
const close = () => {
  push({
    vCategory: 'regform',
    vAction: 'regform_close',
    vLabel: `step_${step.value}`,
  });

  if (step.value > 1) {
    // this modal closes active modal by itself
    return redirectToWelcomeBonus(false);
  }
  // close modal
};

onBeforeUnmount(close);

watch(
  () => regForm.currency,
  () => {
    regErrors.value.currency = '';
  }
);

watch(
  () => regForm.email,
  () => {
    regErrors.value.email = '';
  }
);

watch(
  () => regForm.password,
  () => {
    regErrors.value.password = '';
  }
);

watch(
  () => regForm.terms_acceptance,
  () => {
    regErrors.value.terms_acceptance = '';

    push({
      vCategory: 'regform',
      vAction: 'regform_terms',
    });
  }
);

watch(
  () => profileForm.receive_promos,
  () => {
    push({
      vCategory: 'regform',
      vAction: 'regform_promos',
    });
  }
);

watch(
  () => profileForm.receive_sms_promos,
  () => {
    push({
      vCategory: 'regform',
      vAction: 'regform_sms',
    });
  }
);

watch(
  () => profileForm.first_name,
  () => {
    profileErrors.value.first_name = '';
  }
);

watch(
  () => profileForm.last_name,
  () => {
    profileErrors.value.last_name = '';
  }
);

watch(
  () => profileForm.year,
  () => {
    profileErrors.value.year = '';
  }
);

watch(
  () => profileForm.month,
  () => {
    profileErrors.value.month = '';
  }
);

watch(
  () => profileForm.day,
  () => {
    profileErrors.value.day = '';
  }
);

watch(
  () => profileForm.gender,
  () => {
    profileErrors.value.gender = '';
  }
);

watch(
  () => profileForm.mobile_phone,
  () => {
    profileErrors.value.mobile_phone = '';
  }
);

watch(
  () => profileForm.country,
  () => {
    profileErrors.value.country = '';
  }
);

watch(
  () => profileForm.city,
  () => {
    profileErrors.value.city = '';
  }
);

watch(
  () => profileForm.address,
  () => {
    profileErrors.value.address = '';
  }
);

watch(
  () => profileForm.postal_code,
  () => {
    profileErrors.value.postal_code = '';
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BannerSlider, {
        "slider-type": "signUp",
        "slider-nav": false,
        "slider-change": false,
        "link-disable": true,
        pageData: __props.pageData
      }, null, 8, ["pageData"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("form", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-first-step", { 'modal-hidden-step': step.value != 1 }])
        }, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_unref(regFormData).header), 1),
          (_unref(isDesktop) || _unref(isTablet))
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                _createTextVNode(_toDisplayString(_unref(regFormData).have_account_question) + " ", 1),
                _createElementVNode("a", {
                  href: "#",
                  class: "link",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openLogin && _ctx.openLogin(...args)), ["prevent"]))
                }, _toDisplayString(_unref(regFormData).signin_title), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'form-group-error': !!regErrors.value.email }])
          }, [
            _createElementVNode("input", {
              id: "email",
              value: _unref(regForm).email,
              type: "email",
              name: "email",
              class: "input",
              autocomplete: "email",
              onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(regForm).email = $event.target.value))
            }, null, 40, _hoisted_6),
            _createElementVNode("label", {
              class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(regForm).email }])
            }, _toDisplayString(_unref(regFormData).email_title), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': regErrors.value.email }])
            }, _toDisplayString(regErrors.value.email), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group form-password", { 'form-group-error': !!regErrors.value.password }])
          }, [
            _withDirectives(_createElementVNode("input", {
              id: "password",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(regForm).password) = $event)),
              type: _unref(passwordType),
              name: "password",
              class: "input",
              autocomplete: "current-password"
            }, null, 8, _hoisted_7), [
              [_vModelDynamic, _unref(regForm).password]
            ]),
            _createElementVNode("span", {
              class: "form-password__icon",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (showPasswordToggle()))
            }, _hoisted_9),
            _createElementVNode("span", {
              class: "form-password__icon form-password__show-password",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (showPasswordToggle()))
            }, _hoisted_11),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': regErrors.value.password }])
            }, _toDisplayString(regErrors.value.password), 3),
            _createElementVNode("label", {
              class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(regForm).password }])
            }, _toDisplayString(_unref(regFormData).password_title), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'form-group-error': !!regErrors.value.currency }])
          }, [
            _createVNode(CustomSelect, {
              modelValue: _unref(regForm).currency,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(regForm).currency) = $event)),
              options: _unref(activeCurrenciesOptions)
            }, null, 8, ["modelValue", "options"]),
            _createElementVNode("label", {
              class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(regForm).currency }])
            }, _toDisplayString(_unref(regFormData).currency_title), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': regErrors.value.currency }])
            }, _toDisplayString(regErrors.value.currency), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group form-group__bonus", {
              active: isBonusActive.value,
              'form-group-error': !!regErrors.value.bonus_code,
            }])
          }, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(regFormData).enter_bonus_code_title), 1),
            _createElementVNode("input", {
              id: "bonus",
              value: _unref(regForm).bonus_code,
              type: "text",
              name: "bonus",
              class: "input",
              placeholder: _unref(regFormData).bonus_code_title_message,
              onInput: _cache[6] || (_cache[6] = ($event: any) => (_unref(regForm).bonus_code = $event.target.value))
            }, null, 40, _hoisted_13),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': regErrors.value.bonus_code }])
            }, _toDisplayString(regErrors.value.bonus_code), 3)
          ], 2),
          _createElementVNode("div", {
            class: "form-group",
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (toggleBonusShow()), ["prevent"]))
          }, [
            (!isBonusActive.value)
              ? (_openBlock(), _createElementBlock("a", _hoisted_14, _toDisplayString(_unref(regFormData).bonus_code_title_message), 1))
              : (_openBlock(), _createElementBlock("a", _hoisted_15, _toDisplayString(_unref(regFormData).no_bonus_code_title), 1))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _withDirectives(_createElementVNode("input", {
              id: "agree",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(regForm).terms_acceptance) = $event)),
              class: "form-checkbox__checkbox",
              type: "checkbox",
              name: "agree"
            }, null, 512), [
              [_vModelCheckbox, _unref(regForm).terms_acceptance]
            ]),
            _createElementVNode("label", _hoisted_17, [
              _createTextVNode(_toDisplayString(_unref(regFormData).terms_title) + " ", 1),
              _createElementVNode("a", {
                href: _unref(termsLink),
                class: "link"
              }, _toDisplayString(_unref(regFormData).terms_link_title), 9, _hoisted_18),
              _hoisted_19
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(profileForm).receive_promos) = $event)),
              type: "checkbox",
              name: "checkbox-email",
              class: "form-switch__switch",
              title: _unref(profileFormData).receive_promos_title
            }, null, 8, _hoisted_21), [
              [_vModelCheckbox, _unref(profileForm).receive_promos]
            ]),
            _hoisted_22,
            _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(profileFormData).receive_promos_title), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(profileForm).receive_sms_promos) = $event)),
              type: "checkbox",
              name: "checkbox-email",
              class: "form-switch__switch",
              title: _unref(profileFormData).receive_sms_promos_title
            }, null, 8, _hoisted_25), [
              [_vModelCheckbox, _unref(profileForm).receive_sms_promos]
            ]),
            _hoisted_26,
            _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(profileFormData).receive_sms_promos_title), 1)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              class: "button loader",
              name: "sign-up",
              disabled: waitPlease.value,
              onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (nextStep()), ["prevent"]))
            }, [
              _createTextVNode(_toDisplayString(_unref(regFormData).register_button_title) + " ", 1),
              _hoisted_30
            ], 8, _hoisted_29),
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                  _createTextVNode(_toDisplayString(_unref(regFormData).have_account_question) + " ", 1),
                  _createElementVNode("a", {
                    href: "#",
                    class: "link",
                    onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openLogin && _ctx.openLogin(...args)), ["prevent"]))
                  }, _toDisplayString(_unref(regFormData).signin_title), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_32
        ], 2)
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-two-step", { 'modal-hidden-step': step.value != 2 }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'form-group-error': !!profileErrors.value.first_name }])
          }, [
            _createElementVNode("input", {
              id: "name",
              value: _unref(profileForm).first_name,
              type: "text",
              name: "first-name",
              class: "input",
              onInput: _cache[13] || (_cache[13] = ($event: any) => (_unref(profileForm).first_name = $event.target.value))
            }, null, 40, _hoisted_33),
            _createElementVNode("label", {
              class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(profileForm).first_name }])
            }, _toDisplayString(_unref(profileFormData).first_name_title), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': profileErrors.value.first_name }])
            }, _toDisplayString(profileErrors.value.first_name), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'form-group-error': !!profileErrors.value.last_name }])
          }, [
            _createElementVNode("input", {
              id: "last-name",
              value: _unref(profileForm).last_name,
              type: "text",
              name: "last-name",
              class: "input",
              onInput: _cache[14] || (_cache[14] = ($event: any) => (_unref(profileForm).last_name = $event.target.value))
            }, null, 40, _hoisted_34),
            _createElementVNode("label", {
              class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(profileForm).last_name }])
            }, _toDisplayString(_unref(profileFormData).last_name_title), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': profileErrors.value.last_name }])
            }, _toDisplayString(profileErrors.value.last_name), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'form-group-error': !!profileErrors.value.date_of_birth }])
          }, [
            _createElementVNode("span", _hoisted_35, [
              _createElementVNode("div", null, [
                _createVNode(CustomSelect, {
                  modelValue: _unref(profileForm).year,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(profileForm).year) = $event)),
                  options: _unref(listYears)
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("label", {
                  class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(profileForm).year }])
                }, _toDisplayString(_unref(profileFormData).year_title), 3)
              ]),
              _createElementVNode("div", null, [
                _createVNode(CustomSelect, {
                  modelValue: _unref(profileForm).month,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(profileForm).month) = $event)),
                  options: _unref(listMonths)
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("label", {
                  class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(profileForm).month }])
                }, _toDisplayString(_unref(profileFormData).month_title), 3)
              ]),
              _createElementVNode("div", null, [
                _createVNode(CustomSelect, {
                  modelValue: _unref(profileForm).day,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(profileForm).day) = $event)),
                  options: _unref(listDays)
                }, null, 8, ["modelValue", "options"]),
                _createElementVNode("label", {
                  class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(profileForm).day }])
                }, _toDisplayString(_unref(profileFormData).day_title), 3)
              ])
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': profileErrors.value.date_of_birth }])
            }, _toDisplayString(profileErrors.value.date_of_birth), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group modal-phone", { 'form-group-error': !!profileErrors.value.mobile_phone }])
          }, [
            _createVNode(TelephoneInput, {
              modelValue: _unref(profileForm).mobile_phone,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(profileForm).mobile_phone) = $event)),
              "profile-form-data": _unref(profileFormData),
              "player-country": _unref(userCountry)
            }, null, 8, ["modelValue", "profile-form-data", "player-country"]),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': profileErrors.value.mobile_phone }])
            }, _toDisplayString(profileErrors.value.mobile_phone), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group modal-two-block", { 'form-group-error': !!profileErrors.value.gender }])
          }, [
            _createElementVNode("span", _hoisted_36, [
              _withDirectives(_createElementVNode("input", {
                id: "checkbox1",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(profileForm).gender) = $event)),
                value: "m",
                type: "radio",
                name: "checkbox1",
                class: "modal-input",
                placeholder: _unref(profileFormData).male_title
              }, null, 8, _hoisted_37), [
                [_vModelRadio, _unref(profileForm).gender]
              ]),
              _createElementVNode("label", _hoisted_38, [
                _createElementVNode("span", _hoisted_39, [
                  _createTextVNode(_toDisplayString(_unref(regFormData).label_text_male || 'Male') + " ", 1),
                  _hoisted_40
                ])
              ])
            ]),
            _createElementVNode("span", _hoisted_41, [
              _withDirectives(_createElementVNode("input", {
                id: "checkbox2",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(profileForm).gender) = $event)),
                value: "f",
                type: "radio",
                name: "checkbox1",
                class: "modal-input",
                placeholder: _unref(profileFormData).male_title
              }, null, 8, _hoisted_42), [
                [_vModelRadio, _unref(profileForm).gender]
              ]),
              _createElementVNode("label", _hoisted_43, [
                _createElementVNode("span", _hoisted_44, [
                  _createTextVNode(_toDisplayString(_unref(regFormData).label_text_female || 'Female') + " ", 1),
                  _hoisted_45
                ])
              ])
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': profileErrors.value.gender }])
            }, _toDisplayString(profileErrors.value.gender), 3)
          ], 2),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              class: "modal-back",
              disabled: "disabled",
              style: {"visibility":"hidden"},
              title: _unref(profileFormData).back_button_title
            }, _toDisplayString(_unref(profileFormData).back_button_title), 9, _hoisted_47),
            _createElementVNode("button", {
              class: "button default",
              title: _unref(profileFormData).next_button_title,
              onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (nextStep()), ["prevent"]))
            }, _toDisplayString(_unref(profileFormData).next_button_title), 9, _hoisted_48)
          ])
        ], 2)
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["modal-three-step", { 'modal-hidden-step': step.value != 3 }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'form-group-error': !!profileErrors.value.country }])
          }, [
            _createVNode(CustomSelect, {
              modelValue: _unref(profileForm).country,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(profileForm).country) = $event)),
              options: _unref(countriesList),
              name: "country",
              title: _unref(profileFormData).country_title
            }, null, 8, ["modelValue", "options", "title"]),
            _createElementVNode("label", {
              class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(profileForm).country }])
            }, _toDisplayString(_unref(profileFormData).country_title), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': profileErrors.value.country }])
            }, _toDisplayString(profileErrors.value.country), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'form-group-error': !!profileErrors.value.city }])
          }, [
            _createElementVNode("input", {
              id: "city",
              value: _unref(profileForm).city,
              type: "text",
              name: "city",
              class: "input",
              title: _unref(profileFormData).city_title,
              onInput: _cache[23] || (_cache[23] = ($event: any) => (_unref(profileForm).city = $event.target.value))
            }, null, 40, _hoisted_49),
            _createElementVNode("label", {
              class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(profileForm).city }])
            }, _toDisplayString(_unref(profileFormData).city_title), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': profileErrors.value.city }])
            }, _toDisplayString(profileErrors.value.city), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", { 'form-group-error': !!profileErrors.value.address }])
          }, [
            _createElementVNode("input", {
              id: "address",
              value: _unref(profileForm).address,
              type: "text",
              name: "address",
              class: "input",
              title: _unref(profileFormData).address_title,
              onInput: _cache[24] || (_cache[24] = ($event: any) => (_unref(profileForm).address = $event.target.value))
            }, null, 40, _hoisted_50),
            _createElementVNode("label", {
              class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(profileForm).address }])
            }, _toDisplayString(_unref(profileFormData).address_title), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': profileErrors.value.address }])
            }, _toDisplayString(profileErrors.value.address), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["form-group post-code", { 'form-group-error': !!profileErrors.value.postal_code }])
          }, [
            _createElementVNode("input", {
              id: "code",
              value: _unref(profileForm).postal_code,
              type: "text",
              name: "code",
              class: "input",
              title: _unref(profileFormData).postal_code_title,
              onInput: _cache[25] || (_cache[25] = ($event: any) => (_unref(profileForm).postal_code = $event.target.value))
            }, null, 40, _hoisted_51),
            _createElementVNode("label", {
              class: _normalizeClass(["placeholder", { 'placeholder-focus': _unref(profileForm).postal_code }])
            }, _toDisplayString(_unref(profileFormData).postal_code_title), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["error-text", { 'modal-error-show': profileErrors.value.postal_code }])
            }, _toDisplayString(profileErrors.value.postal_code), 3)
          ], 2),
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("button", {
              class: "modal-back",
              title: _unref(profileFormData).back_button_title,
              disabled: waitPlease.value,
              onClick: _cache[26] || (_cache[26] = _withModifiers(($event: any) => (prevStep()), ["prevent"]))
            }, _toDisplayString(_unref(profileFormData).back_button_title), 9, _hoisted_53),
            _createElementVNode("button", {
              class: "button default loader",
              title: _unref(profileFormData).save_button_title,
              disabled: waitPlease.value,
              onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (nextStep()), ["prevent"]))
            }, [
              _createTextVNode(_toDisplayString(_unref(profileFormData).save_button_title) + " ", 1),
              _hoisted_55
            ], 8, _hoisted_54)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["modal-four-step", { 'modal-hidden-step': step.value != 4 }])
        }, [
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("h4", _hoisted_57, _toDisplayString(_unref(regFormData).welcome_title), 1),
            _hoisted_58
          ])
        ], 2)
      ])
    ])
  ]))
}
}

})